import { z } from "zod";
import { ContentItemSchema } from "../ContentItem";
export const ContentListSchema = z.object({
    contentList: z.array(ContentItemSchema),
});
//# sourceMappingURL=index.js.map